import { csx } from '@vtex/admin-ui'
import React from 'react'

const AvailableIcon = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill="#016810" />
  </svg>
)

const UnavailableIcon = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="3.5" fill="white" stroke="#D31A15" />
  </svg>
)

export type AvailabilityStatusIconProps = {
  status: 'available' | 'unavailable'
}

export const AvailabilityStatusIcon = ({
  status,
}: AvailabilityStatusIconProps) => (
  <div className={csx({ display: 'inline-block', marginLeft: '$space-2' })}>
    {status === 'available' ? <AvailableIcon /> : <UnavailableIcon />}
  </div>
)
